module.exports = __webpack_public_path__ + "static/img/f12.abfe037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f12.png
// module id = Rdqi
// module chunks = 34